<template>
<c-app>
  <c-content>
    <c-header>
      <div class="l-container">
        <nav class="navbar u-pl-0 u-pr-0 navbar--light">
            <div class="navbar__start">
                <a class="navbar__item" @click="onDocuments"><span class="i-text"><i class="icon-files-empty"></i><span>Documents</span></span></a>
                <a class="navbar__item" @click="onStatistics"><span class="i-text"><i class="icon-stats-bars"></i><span>Statistics</span></span></a>
                <a class="navbar__item" @click="onAdmin" v-if="isInRole('client-admin')"><span class="i-text"><i class="icon-cog3"></i><span>Settings</span></span></a>
                <a class="navbar__item" @click="onClients" v-if="isInRole('admin')"><span class="i-text"><i class="icon-users"></i><span>Clients</span></span></a>
            </div>
            <div class="navbar__end">
                <UserInfoDisplay slot="content"></UserInfoDisplay>
            </div>
        </nav>
      </div>
    </c-header>
    <router-view></router-view>
    <c-footer>
        <div class="l-container u-text-center u-text-muted u-fs-12">
            <p>© {{ new Date().getFullYear() }} Digital Keez</p>
        </div>
    </c-footer>
  </c-content>
</c-app>
</template>
<script>

import UserInfoDisplay from './UserInfoDisplay'
import { mapGetters } from 'vuex'

export default {
  name: 'UserHome',
  components: {
    UserInfoDisplay
  },

  data () {
    return {
      role: ''
    }
  },

  computed: {
    ...mapGetters('auth', ['isInRole'])
  },

  created () {
    if (this.isInRole('admin')) {
      // go to admin sub-site
      // this.$router.push({name: 'Admin'})
    } else {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push(this.$router.currentRoute)
      } else {
        this.$router.push({name: 'UserDocuments'})
      }
    }
  },

  methods: {
    onDocuments () {
      this.$router.push({name: 'UserDocuments'})
    },
    onAdmin () {
      this.$router.push({name: 'UserAdmin'})
    },
    onStatistics () {
      this.$router.push({name: 'UserStatistics'})
    },
    onClients () {
      this.$router.push({name: 'Admin'})
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/components/UserHome.vue